import { Box, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthContext from '../../store/auth-context';
import {
	allWhatsNewForRole,
	CURRENT_APP_VERSION,
	groupWhatsNewByVersion,
	roleToWhatsNewAudience,
} from '../../whats-new';

/**
 * Pełna lista „Co nowego” dla zalogowanej roli panelu.
 * Nowi użytkownicy nie dostają dialogu startowego — tu mogą zajrzeć świadomie.
 */
const WhatsNewPage = () => {
	const { role } = useContext(AuthContext);
	const audienceRole = roleToWhatsNewAudience(role);

	const groups = useMemo(() => {
		if (!audienceRole || audienceRole === 'student') {
			return [];
		}
		return groupWhatsNewByVersion(allWhatsNewForRole({ role: audienceRole, currentVersion: CURRENT_APP_VERSION }));
	}, [audienceRole]);

	if (!audienceRole || audienceRole === 'student') {
		return (
			<Typography
				variant='body1'
				sx={{ p: 2 }}
			>
				Ta strona jest dostępna w panelu dla administratora, sekretarza i nauczyciela.
			</Typography>
		);
	}

	return (
		<Box sx={{ p: { xs: 2, sm: 0 }, maxWidth: 720, pb: 6 }}>
			<Typography
				variant='body1'
				color='text.secondary'
				sx={{ mb: 3 }}
			>
				Skrót zmian w pracy w panelu (wersja aplikacji {CURRENT_APP_VERSION}). Więcej materiałów:{' '}
				<Link
					component={RouterLink}
					to='/panel/pomoc'
				>
					Pomoc
				</Link>
				.
			</Typography>
			{groups.length === 0 ? (
				<Typography variant='body1'>Brak wpisów dla Twojej roli.</Typography>
			) : (
				groups.map(({ version, items }) => (
					<Box
						key={version}
						sx={{ mb: 4 }}
					>
						<Typography
							variant='h6'
							sx={{ mb: 1 }}
						>
							Wersja {version}
						</Typography>
						{items.map((item, idx) => (
							<Box
								key={`${version}-${item.title}-${idx}`}
								sx={{ mb: 2 }}
							>
								<Typography
									variant='subtitle1'
									fontWeight={600}
								>
									{item.title}
								</Typography>
								<List dense>
									{item.bullets.map((bullet, bIdx) => (
										<ListItem
											key={bIdx}
											sx={{ py: 0.25, alignItems: 'flex-start' }}
										>
											<ListItemText
												primary={bullet}
												primaryTypographyProps={{ variant: 'body2' }}
											/>
										</ListItem>
									))}
								</List>
								{item.helpHref ? (
									<Link
										component={RouterLink}
										to={item.helpHref}
										variant='body2'
									>
										Więcej w pomocy
									</Link>
								) : null}
							</Box>
						))}
					</Box>
				))
			)}
		</Box>
	);
};

export default WhatsNewPage;
